<ngx-json-ld [json]="schema"></ngx-json-ld>
<a *ngIf="item" [routerLink]="detailViewUrl" (click)="onItemClicked.emit()">
<div [class]="gridItemClass" [title]="item.title">

  <app-ribbon *ngIf="item && item.popularityBadge && !inOwnlist"></app-ribbon>

  <div [class]="imageContainerClass">

    <img loading="lazy" [alt]="item.title" *ngIf="showPlaceHolder || showRemovedItemPlaceholder()" [class]="imageClass + ' placeholder-img'" [class.hidden]="highResImageLoaded == true && !showRemovedItemPlaceholder()"
    src="./assets/images/item_placeholder.png">

    <div class="placeholder-text" *ngIf="showPlaceHolder && !showRemovedItemPlaceholder()">{{item.title}}</div>
    <div class="removed-item-overlay" *ngIf="showRemovedItemPlaceholder()">
      <span class="material-icons removed-item-icon">close</span>
      <span class="removed-item-title">{{getRemovedItemTitle()}}</span>
    </div>

    <img loading="lazy" [alt]="getImgAlt()" *ngIf="(!useIvan() || !storeIsItunes()) && showPlaceHolder == false && !showRemovedItemPlaceholder() && getHttpsImageUrl() != ''" [class.hidden]="highResImageLoaded == true"
    [class]="imageClass"
    [src]="getHttpsImageUrl()"
    (error)="showPlaceHolder = true">

    <img loading="lazy" [alt]="getImgAlt()" *ngIf="useIvan() && storeIsItunes() && !showRemovedItemPlaceholder()" [class.hidden]="highResImageLoaded == false"
    [class]="imageClass"
    [src]="getItemImageUrl()"
    (load)="highResImageLoaded = true" (error)="highResImageLoaded = false">

    <app-small-flags class="flags-container" [flags]="item.flags"></app-small-flags>
    <app-rank *ngIf="item.rank" class="rank-container" [rank]="item.rank" [rankDropIndicator]="item.rankDropIndicator"></app-rank>

    <div class="type-label" *ngIf="item.isBundle || item.isMovieBundle || item.isSeasonBundle">{{getString('bundle')}}</div>

    <!-- Wishlist star indicator top right -->
    <ng-container *ngIf="inWishlist">
      <div class="wishlist-indicator"></div>
      <img loading="lazy" alt="" class="wishlist-star-indicator" [title]="getString('removeFromWishlist')" src="./assets/images/star_filled_blue.png" (click)="removeFromWishlist($event)">
    </ng-container>

    <!-- Badges oben links (Preorder, Owned, Blocked können alle angezeigt werden) -->
    <span *ngIf="item.isPreorder" class="preorder-badge">{{getString('preorder')}}</span>
    <div class="owned-badge" *ngIf="inOwnlist" [class.has-preorder]="item.isPreorder" (click)="removeFromOwnlist($event)">
      <span>{{getString('purchased')}}</span>
    </div>
    <div class="blocked-badge" *ngIf="inBlocklist" [class.has-preorder]="item.isPreorder" [class.has-owned]="inOwnlist"
      (click)="removeFromBlocklist($event)" [title]="getString('removeFromBlocklist')">
      <span class="material-icons blocked-icon">block</span><span>{{getString('blocked')}}</span>
    </div>

    <!-- Bottom action bar on hover -->
    <div class="quick-actions-bar">
      <div class="quick-action" [class.active]="inWishlist" (click)="inWishlist ? removeFromWishlist($event) : addToWishlist($event)">
        <img loading="lazy" alt=""
          [src]="inWishlist ? './assets/images/star_filled_blue.png' : './assets/images/star_filled_black.png'">
        <span class="action-label">{{getString('wishlist')}}</span>
      </div>
      <div class="quick-action" [class.active]="inOwnlist" (click)="inOwnlist ? removeFromOwnlist($event) : addToOwnlist($event)">
        <img loading="lazy" alt=""
          src="./assets/images/my_purchases_check.png">
        <span class="action-label">{{getString('purchased')}}</span>
      </div>
      <div class="quick-action blocklist-action" [class.active]="inBlocklist" (click)="inBlocklist ? removeFromBlocklist($event) : addToBlocklist($event)">
        <span class="material-icons quick-action-icon">block</span>
        <span class="action-label">{{getString('blocklist')}}</span>
      </div>
    </div>

  </div>

  <div [class]="footerClass">
    <div class="grid-item-footer-top txt-algn-cntr" *ngIf="showFooterTop">
      <app-ratings *ngIf="item.imdbRating || item.tomatoesScore" [imdbId]="item.imdbId" [imdbRating]="item.imdbRating"
      [tomatoesRating]="item.tomatoesScore" [metacriticRating]="item.metacritic" [letterboxdRating]="item.letterboxdRating"></app-ratings>
      <div *ngIf="item.itemType != 'movie'" class="artist-title">
        <span *ngIf="item.itemType != 'season' && item.itemType != 'app' && item.itemType != 'macapp'">{{item.artist}}
          <span *ngIf="item.artist && item.title">-</span>
        </span>
         {{item.title}}
         <app-rating *ngIf="item.userRating" [rating]="item.userRating"></app-rating>
      </div>

      <div *ngIf="item.itemType == 'movie' && item.saveOpportunity && !isCarouselItem" class="save-opportunity">
          {{getString('save')}} <span class="color-green">{{formatPrice(item.saveOpportunity, item.currency)}}</span> {{getString('withThisBundle')}}
      </div>

    </div>

    <div class="float-right">
      <app-grid-item-prices [item]="item" [priceHint]="priceHint" ></app-grid-item-prices>
    </div>

    <div class="float-left">
      <img loading="lazy" alt="" *ngIf="item.has3D == 1 && !urlIsHomePage()" class="quality-icon" src="./assets/images/3d-icon-avp-grey.png">
      <img loading="lazy" alt="" *ngIf="item.has4K == 1 && !urlIsHomePage() && showQuality" class="quality-icon" src="./assets/images/4k-icon.png">
      <img loading="lazy" alt="" *ngIf="item.iTunesExtra && !urlIsHomePage() && item.has3D == 0" class="itunes-extras-icon" src="./assets/images/itunes_extras.png">
      <img loading="lazy" alt="" *ngIf="item.moviesAnywhere && !urlIsHomePage()" class="itunes-extras-icon" src="./assets/images/m_anywhere.png">
    </div>
  </div>
</div>
</a>

